import { Footer } from 'app/core/footer/Footer';
import { Header } from 'app/core/header/Header';
import { FormApi } from 'final-form';
import React, { Fragment, useContext, useState } from 'react';
import { AlertBox, Column, Layout, Loader, LocaleContext, PageHeader, Row } from 'shared';
import { ChangePasswordPayload } from 'store/api/types';

import { useQuery } from '../../shared/hooks';

import { ChangePasswordWrapper } from './ChangePassword.styles';
import { ChangePasswordProps } from './ChangePassword.types';
import { ChangePasswordForm } from './changePasswordForm/ChangePasswordForm';

export const ChangePassword = ({
  onChangePassword,
  onValidateToken,
  match: {
    params: { token },
  },
}: ChangePasswordProps) => {
  const [isSubmitSuccess, setSubmitSuccess] = useState(false);
  const [isSubmitFailed, setSubmitFailed] = useState(false);
  const localeContext = useContext(LocaleContext);
  const { loading, response, error } = useQuery(onValidateToken);

  const handleSubmit = async (values: ChangePasswordPayload, formApi: FormApi) => {
    try {
      return await onChangePassword({ ...values, token }, formApi, () => {
        setSubmitSuccess(true);
      });
    } catch (error) {
      setSubmitFailed(true);
    }
  };

  if (loading) {
    return <Loader fullScreen={true} />;
  }

  return (
    <Layout header={<Header />} footer={<Footer />}>
      <Row height="100%">
        <Column>
          <ChangePasswordWrapper className="change-password">
            <Row height="100%">
              <Column size={[0, 3, 4]} />
              <Column size={[12, 6, 4]} className="change-password__content">
                {response && (
                  <Fragment>
                    <PageHeader>{localeContext.formatMessage({ id: 'CHANGE-PASSWORD.FORM.TITLE' })}</PageHeader>
                    {isSubmitSuccess && (
                      <AlertBox
                        type={AlertBox.types.SUCCESS}
                        title={localeContext.formatMessage({ id: 'CHANGE-PASSWORD.SUCCESS.TITLE' })}
                      >
                        {localeContext.formatMessage({ id: 'CHANGE-PASSWORD.SUCCESS.CONTENT' })}
                      </AlertBox>
                    )}
                    {!isSubmitSuccess && <ChangePasswordForm onSubmit={handleSubmit} isSubmitFailed={isSubmitFailed} />}
                  </Fragment>
                )}
                {error && (
                  <AlertBox
                    type={AlertBox.types.FAIL}
                    title={localeContext.formatMessage({ id: 'CHANGE-PASSWORD-TOKEN.FAIL.TITLE' })}
                  >
                    {localeContext.formatMessage({ id: 'CHANGE-PASSWORD-TOKEN.FAIL.CONTENT' })}
                  </AlertBox>
                )}
              </Column>
              <Column size={[0, 3, 4]} />
            </Row>
          </ChangePasswordWrapper>
        </Column>
      </Row>
    </Layout>
  );
};
